const CARD_NUMBER_IDS = [
  'card_number',
  'cardNumber',
  'card-number',
  'cc_number',
];
const CARD_NUMBER_NAMES = ['card_number', 'cardNumber', 'cc_number'];
const CVV_IDS = ['cvv', 'cvc', 'security_code'];
const CVV_NAMES = ['cvv', 'cvc', 'security_code'];

function isVisibleInput(el: HTMLInputElement): boolean {
  return el.type !== 'hidden' && !el.disabled;
}

function inputHasValue(input: HTMLInputElement): boolean {
  return input.value.length > 0;
}

function resolveRoot(root?: ParentNode | null): ParentNode | null {
  if (typeof document === 'undefined') return null;
  return root ?? document;
}

function findStartedByIdOrName(
  ids: string[],
  names: string[],
  root?: ParentNode | null
): boolean {
  const scope = resolveRoot(root);
  if (!scope) return false;

  for (const id of ids) {
    const el =
      scope === document
        ? document.getElementById(id)
        : scope.querySelector(`#${cssEscape(id)}`);
    if (
      el instanceof HTMLInputElement &&
      isVisibleInput(el) &&
      inputHasValue(el)
    ) {
      return true;
    }
  }

  for (const name of names) {
    const elements = scope.querySelectorAll(`input[name="${name}"]`);
    for (const el of elements) {
      if (
        el instanceof HTMLInputElement &&
        isVisibleInput(el) &&
        inputHasValue(el)
      ) {
        return true;
      }
    }
  }

  return false;
}

function findStartedByAutocomplete(
  value: string,
  root?: ParentNode | null
): boolean {
  const scope = resolveRoot(root);
  if (!scope) return false;

  const elements = scope.querySelectorAll(`input[autocomplete="${value}"]`);
  for (const el of elements) {
    if (
      el instanceof HTMLInputElement &&
      isVisibleInput(el) &&
      inputHasValue(el)
    ) {
      return true;
    }
  }

  return false;
}

function cssEscape(value: string): string {
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(value);
  }
  return value.replace(/([^a-zA-Z0-9_-])/g, '\\$1');
}

/**
 * Detecta início de preenchimento — nenhum valor é armazenado ou retornado.
 * `root` restringe a busca (ex.: formSelector do PaymentSource).
 */
export function scanPaymentInputStarted(root?: ParentNode | null): boolean {
  return (
    findStartedByAutocomplete('cc-number', root) ||
    findStartedByIdOrName(CARD_NUMBER_IDS, CARD_NUMBER_NAMES, root) ||
    findStartedByAutocomplete('cc-exp', root) ||
    findStartedByAutocomplete('cc-exp-month', root) ||
    findStartedByAutocomplete('cc-exp-year', root) ||
    findStartedByAutocomplete('cc-csc', root) ||
    findStartedByIdOrName(CVV_IDS, CVV_NAMES, root)
  );
}
